export default __webpack_public_path__ + "c9e92123f4c733beb5aaff7d0ff160bc.png";